@file:OptIn(InternalResourceApi::class)

package kotlinproject.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/kotlinproject.composeapp.generated.resources/"

@delegate:ResourceContentHash(679_086_888)
internal val Res.drawable.board_frame: DrawableResource by lazy {
      DrawableResource("drawable:board_frame", setOf(
        ResourceItem(setOf(), "${MD}drawable/board_frame.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_761_550_943)
internal val Res.drawable.bomb: DrawableResource by lazy {
      DrawableResource("drawable:bomb", setOf(
        ResourceItem(setOf(), "${MD}drawable/bomb.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.bomb_face_1: DrawableResource by lazy {
      DrawableResource("drawable:bomb_face_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/bomb_face_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.bomb_face_2: DrawableResource by lazy {
      DrawableResource("drawable:bomb_face_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/bomb_face_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_901_482_632)
internal val Res.drawable.button_round: DrawableResource by lazy {
      DrawableResource("drawable:button_round", setOf(
        ResourceItem(setOf(), "${MD}drawable/button_round.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-995_443_571)
internal val Res.drawable.button_round_pressed: DrawableResource by lazy {
      DrawableResource("drawable:button_round_pressed", setOf(
        ResourceItem(setOf(), "${MD}drawable/button_round_pressed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_807_472_863)
internal val Res.drawable.cell_dark: DrawableResource by lazy {
      DrawableResource("drawable:cell_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-89_169_628)
internal val Res.drawable.cell_light: DrawableResource by lazy {
      DrawableResource("drawable:cell_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_light.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_470_187_659)
internal val Res.drawable.cross_bomb: DrawableResource by lazy {
      DrawableResource("drawable:cross_bomb", setOf(
        ResourceItem(setOf(), "${MD}drawable/cross_bomb.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_1: DrawableResource by lazy {
      DrawableResource("drawable:face_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_2: DrawableResource by lazy {
      DrawableResource("drawable:face_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_3: DrawableResource by lazy {
      DrawableResource("drawable:face_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_4: DrawableResource by lazy {
      DrawableResource("drawable:face_4", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_4.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_5: DrawableResource by lazy {
      DrawableResource("drawable:face_5", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(242_842_241)
internal val Res.drawable.face_6: DrawableResource by lazy {
      DrawableResource("drawable:face_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/face_6.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-16_554_979)
internal val Res.drawable.game_background: DrawableResource by lazy {
      DrawableResource("drawable:game_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/game_background.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(791_962_980)
internal val Res.drawable.ice_1: DrawableResource by lazy {
      DrawableResource("drawable:ice_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/ice_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(851_243_714)
internal val Res.drawable.ice_2: DrawableResource by lazy {
      DrawableResource("drawable:ice_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/ice_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_700_561_347)
internal val Res.drawable.ice_3: DrawableResource by lazy {
      DrawableResource("drawable:ice_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/ice_3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(928_312_462)
internal val Res.drawable.jelly_1: DrawableResource by lazy {
      DrawableResource("drawable:jelly_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_246_326_377)
internal val Res.drawable.jelly_2: DrawableResource by lazy {
      DrawableResource("drawable:jelly_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_245_659_558)
internal val Res.drawable.jelly_3: DrawableResource by lazy {
      DrawableResource("drawable:jelly_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(865_379_531)
internal val Res.drawable.jelly_4: DrawableResource by lazy {
      DrawableResource("drawable:jelly_4", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_4.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(582_909_831)
internal val Res.drawable.jelly_5: DrawableResource by lazy {
      DrawableResource("drawable:jelly_5", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_194_750_189)
internal val Res.drawable.jelly_6: DrawableResource by lazy {
      DrawableResource("drawable:jelly_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/jelly_6.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(770_393_391)
internal val Res.drawable.laser: DrawableResource by lazy {
      DrawableResource("drawable:laser", setOf(
        ResourceItem(setOf(), "${MD}drawable/laser.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_140_134_939)
internal val Res.drawable.parchment_bg: DrawableResource by lazy {
      DrawableResource("drawable:parchment_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/parchment_bg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-245_985_151)
internal val Res.drawable.swirl: DrawableResource by lazy {
      DrawableResource("drawable:swirl", setOf(
        ResourceItem(setOf(), "${MD}drawable/swirl.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("board_frame", Res.drawable.board_frame)
  map.put("bomb", Res.drawable.bomb)
  map.put("bomb_face_1", Res.drawable.bomb_face_1)
  map.put("bomb_face_2", Res.drawable.bomb_face_2)
  map.put("button_round", Res.drawable.button_round)
  map.put("button_round_pressed", Res.drawable.button_round_pressed)
  map.put("cell_dark", Res.drawable.cell_dark)
  map.put("cell_light", Res.drawable.cell_light)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("cross_bomb", Res.drawable.cross_bomb)
  map.put("face_1", Res.drawable.face_1)
  map.put("face_2", Res.drawable.face_2)
  map.put("face_3", Res.drawable.face_3)
  map.put("face_4", Res.drawable.face_4)
  map.put("face_5", Res.drawable.face_5)
  map.put("face_6", Res.drawable.face_6)
  map.put("game_background", Res.drawable.game_background)
  map.put("ice_1", Res.drawable.ice_1)
  map.put("ice_2", Res.drawable.ice_2)
  map.put("ice_3", Res.drawable.ice_3)
  map.put("jelly_1", Res.drawable.jelly_1)
  map.put("jelly_2", Res.drawable.jelly_2)
  map.put("jelly_3", Res.drawable.jelly_3)
  map.put("jelly_4", Res.drawable.jelly_4)
  map.put("jelly_5", Res.drawable.jelly_5)
  map.put("jelly_6", Res.drawable.jelly_6)
  map.put("laser", Res.drawable.laser)
  map.put("parchment_bg", Res.drawable.parchment_bg)
  map.put("swirl", Res.drawable.swirl)
}
